import { createAsyncThunk } from "@reduxjs/toolkit";
import { PostVouchersBody, PostVouchersResponse } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const postVouchers = createAsyncThunk<
  PostVouchersResponse,
  PostVouchersBody
>("vouchers/postVouchers", async (body, { rejectWithValue }) => {
  try {
    const data = await VouchersAPI.postVouchers(body);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while creating vouchers", error.response?.data);
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while creating vouchers", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
